import React from "react";
import Component from "components";
import Banner from "./banner";
import About from "./about";
import Videos from "./videos";
import Service from "./service";
import Portofolio from "./portofolio";
import Client from "./client";
import Testimonial from "./testimonial";
import Award from "./award";
import Divider from "./divider";
import "assets/styles/home.less";
import data from "./data";

// const About       = React.lazy(() => import('./about'));
// const Videos      = React.lazy(() => import('./videos'));
// const Service     = React.lazy(() => import('./service'));
// const Portofolio  = React.lazy(() => import('./portofolio'));
// const Client      = React.lazy(() => import('./client'));
// const Testimonial = React.lazy(() => import('./testimonial'));
// const Award       = React.lazy(() => import('./award'));

const Home : React.FC = () => {

    return (
       <Component.Publiclayout>
           <Component.Metadecorator
               title={data.meta.title}
               description={data.meta.description}
               imageUrl={data.meta.imageUrl}
               imageAlt={data.meta.imageAlt}
           />
           <section className={"home-wrapper"}>
               <Banner />
               <Divider imageURL={"/images/divider/divider-1.png"} />
               <About />
               <Videos />
               <Service />
               <Divider imageURL={"/images/divider/divider-2.png"} />
               <Portofolio />
               <Divider imageURL={"/images/divider/divider-3.png"} />
               <Client />
               <Divider imageURL={"/images/divider/divider-4.png"} />
               <Testimonial />
               <Award />
           </section>
       </Component.Publiclayout>
    )
}

export default Home;